import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ILoggedInUser } from "../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../services/common/logged-in-user.service";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { TreasuryRateModel } from "../models/treasury-rate.model";
import { TreasuryRateService } from "../services/treasury-rate.service";
import { Months } from "../../shared/models/months.model";
import { ManageTreasuryRateComponent } from "./manage-treasury-rate/manage-treasury-rate.component";
import { SearchParameters } from "../../shared/models/searchParameters.model";
import { PagedResult } from "../../shared/models/pagedResult.model";

@Component({
  selector: "app-treasury-rate",
  templateUrl: "./treasury-rate.component.html",  
  standalone: true,  
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule],
})
export class TreasuryRateComponent implements OnInit {
  title = "";
  isLoading: boolean = false;
  dataSource: MatTableDataSource<TreasuryRateModel>;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  displayedColumns: string[] = ['number', 'exchangeRate', 'year', 'month', 'currFrom', 'currTo'];
  searchDone: boolean = false;
  searchForm: FormGroup; 
  searchRequestParams: SearchParameters<TreasuryRateModel>
  months = [];
  pagedData: PagedResult<TreasuryRateModel[]>;
  pageSize: number;
  totalCount: number;

  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private treasuryRateService: TreasuryRateService,    
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.months = Object.values(Months).filter(value => typeof value === 'string') as string[];
    this.searchForm = this.fb.group({
      treasuryRate: new FormControl(''),
      year: new FormControl(''),
      month: new FormControl(''),
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.searchAll()       
      }      
    });
    this.dialogClose()
  }

  searchAll() {
    if(this.isAdmin){
      this.isLoading = true;
      this.treasuryRateService.searchAllTreasuryRate(this.user.userEmail, this.pageSize || 10)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount; 
          this.dataSource = new MatTableDataSource<TreasuryRateModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
  }

  search() {
    if(this.isAdmin){
      this.isLoading = true;
      this.treasuryRateService.searchTreasuryRate(this.searchRequestParams)
        .subscribe(data => {    
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;     
          this.dataSource = new MatTableDataSource<TreasuryRateModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<TreasuryRateModel>([]);
    }
  }  

  submitForm(): void {  
    
    this.searchRequestParams = {
      query: {
        exchangeRate: this.searchForm.get('treasuryRate').value || 0,
        year: this.searchForm.get('year').value || 0,
        month: Months[this.searchForm.get('month').value as keyof typeof Months] || 0,
        currId: 0
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };    

    this.search();
  }

  clear(){
    this.searchForm.reset();
    this.searchAll();
  }

  dialogClose(){
    this.dialog.afterAllClosed.subscribe(() => {
      if(this.searchForm && this.searchForm.dirty && this.searchForm.touched){
        this.submitForm();
      }else{
        this.searchAll();
      }
    });
  }
  
  openDialog(id: number): void {
    if(this.isAdmin){
      this.dialog.open(ManageTreasuryRateComponent,{
        data: id
      });
    }    
  }

  getMonthName(number: number): string {
    return Months[number];
  }
  
  public pageChangeEvent(event?:PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search();
  }
}
